<div class="cb-margin-2x flex-col" *cbWaitFor="mappedItem && designScheme">
    <div class="flex-row">
        <div class="flex-col md-60 lg-40 sm-80 xl-20 xs-100">
            <div class="flex-row">
                <cb-display-value-new
                    class="flex"
                    label="Name"
                    [value]="mappedItem.designSchemeName"
                ></cb-display-value-new>
                <cb-display-value-new
                    class="flex"
                    label="Build Type"
                    [value]="buildTypes[designScheme.buildTypeId]"
                ></cb-display-value-new>
            </div>
        </div>
    </div>
    <div class="flex-row">
        <div class="flex-col md-60 lg-40 sm-80 xl-20 xs-100">
            <div class="flex-row">
                <cb-display-value-new class="flex" label="Land Area">
                    <div class="start-center flex-row">
                        <mat-icon class="cb-grey">border_style</mat-icon>
                        <span class="mat-body-2"
                            >&nbsp;{{ mappedItem?.amenities?.landArea }}m&#178;</span
                        >
                    </div>
                </cb-display-value-new>
                <cb-display-value-new class="flex" label="Floor Area">
                    <div class="start-center flex-row">
                        <mat-icon class="cb-grey" svgIcon="floor-plan"></mat-icon>
                        <span class="mat-body-2"
                            >&nbsp;{{ mappedItem?.amenities?.floorArea }}m&#178;</span
                        >
                    </div>
                </cb-display-value-new>
            </div>
            <div class="flex-row">
                <cb-display-value-new class="flex" label="Bedroom">
                    <div class="start-center flex-row">
                        <mat-icon class="cb-grey">hotel</mat-icon>
                        <span class="mat-body-2"
                            >&nbsp;{{ mappedItem?.amenities?.noBedrooms }}</span
                        >
                    </div>
                </cb-display-value-new>
                <cb-display-value-new class="flex" label="Bathroom">
                    <div class="start-center flex-row">
                        <mat-icon class="cb-grey">wc</mat-icon>
                        <span class="mat-body-2"
                            >&nbsp;{{ mappedItem?.amenities?.noBathrooms }}</span
                        >
                    </div>
                </cb-display-value-new>
            </div>
            <div class="flex-row">
                <cb-display-value-new class="flex" label="Living">
                    <div class="start-center flex-row">
                        <mat-icon class="cb-grey">weekend</mat-icon>
                        <span class="mat-body-2"
                            >&nbsp;{{ mappedItem?.amenities?.noLivingRooms }}</span
                        >
                    </div>
                </cb-display-value-new>
                <cb-display-value-new class="flex" label="Garage">
                    <div class="start-center flex-row">
                        <mat-icon class="cb-grey">directions_car</mat-icon>
                        <span class="mat-body-2">&nbsp;{{ mappedItem?.amenities?.noGarages }}</span>
                    </div>
                </cb-display-value-new>
            </div>
        </div>
    </div>
    <div class="checkbox-list flex-col">
        <cb-checkbox
            label="Resource Consent Required"
            name="resourceConsentRequird"
            [(ngModel)]="designScheme.resourceConsentRequired"
            [readonly]="true"
        ></cb-checkbox>
    </div>
    <cb-text-area
        label="Design Requirements"
        name="designRequirements"
        [(ngModel)]="designScheme.designRequirements"
        [readonly]="true"
    ></cb-text-area>
    <div class="flex-col">
        <cb-display-value-new label="Failed Review History">
            <div class="flex-row flex">
                <div class="flex-row">
                    <mat-divider [vertical]="true" class="cb-margin-right"></mat-divider>
                </div>
                <ul class="cb-list flex-col flex">
                    @for (item of designScheme.failedReviewHistories; track item) {
                        <li>
                            <span>{{ item.createdDate | date }} - {{ item.createdByName }}</span>
                            <p>{{ item.notes }}</p>
                        </li>
                    }
                </ul>
            </div>
        </cb-display-value-new>
        @if (displayRejectionNotes()) {
            <cb-display-value-new
                label="Rejection Notes"
                [value]="designScheme.rejectionNotes"
            ></cb-display-value-new>
        }
    </div>
    <cb-display-value-new
        label="Standard Plan"
        [value]="designScheme.standardPlanLabel"
    ></cb-display-value-new>
    <cb-display-value-new
        label="Approver"
        [value]="designScheme.approverUserName"
    ></cb-display-value-new>
    <cb-user-date-time-new
        label="Requested by"
        [userFullName]="mappedItem.createdByUserName"
        [date]="mappedItem.createdDate"
        [floatingLabel]="true"
        [displayTime]="false"
    ></cb-user-date-time-new>
    <cb-user-date-time-new
        label="Finalised by"
        [userFullName]="mappedItem.finalisedByUserName"
        [date]="mappedItem.finalisedDate"
        [floatingLabel]="true"
        [displayTime]="false"
    ></cb-user-date-time-new>
    <cb-user-date-time-new
        label="Accepted by"
        [userFullName]="designScheme.acceptedByUserName"
        [date]="designScheme.acceptedDate"
        [floatingLabel]="true"
        [displayTime]="false"
    ></cb-user-date-time-new>
    <cb-text-area
        label="Specification Version"
        name="lotSpecVersion"
        [(ngModel)]="designScheme.lotSpecVersion"
        [readonly]="true"
    ></cb-text-area>
    <cb-currency
        class="flex"
        label="Client Budget"
        name="clientBudget"
        [(ngModel)]="designScheme.clientBudget"
        [readonly]="true"
        [inclGst]="true"
        [formatCredit]="true"
    ></cb-currency>
    @if (rejectionHistories?.value?.length > 0) {
        <cb-display-value-new label="Rejection Histories">
            <ul class="cb-list">
                @for (history of rejectionHistories.value; track history) {
                    <li class="flex-col">
                        <cb-user-date-time-new
                            label="Rejected by"
                            [userFullName]="history.createdByName"
                            [date]="history.createdDate"
                            [floatingLabel]="false"
                            [displayTime]="true"
                        ></cb-user-date-time-new>
                        <div class="cb-margin-left flex-row flex">
                            <mat-divider [vertical]="true"></mat-divider>
                            <span class="cb-margin-left mat-body-2 flex">{{ history.notes }}</span>
                        </div>
                    </li>
                }
            </ul>
        </cb-display-value-new>
    }
</div>
